import React, { useEffect } from "react";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pager: {},
      initialPage: props.initialPage || 1,
    };
  }

  componentDidMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage || this.state.initialPage);
      this.setState({
        pageSize: this.props.pageSize,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // reset page if items array has changed
    if (
      this.props.items !== prevProps.items &&
      !this.props.serverSide // Only specific logic for client-side items change
    ) {
      this.setPage(this.state.initialPage);
    }

    // Handle server-side page changes or external resets
    if (this.props.initialPage !== prevProps.initialPage) {
      this.setPage(this.props.initialPage);
    }

    // Recalculate pager if totalItems changes (for server-side pagination)
    if (this.props.totalItems !== prevProps.totalItems) {
      this.setPage(this.props.initialPage || this.state.initialPage);
    }
  }

  setPage = (page) => {
    let { items, pageSize, serverSide, totalItems } = this.props;
    let pager = this.state.pager;
    const totalCount = totalItems || (items ? items.length : 0);

    // no results (e.g. a filter matched nothing) - tell the parent so it can clear the table
    // instead of leaving whatever was rendered before the filter ran
    if (totalCount === 0) {
      pager = this.getPager(0, 1, pageSize);
      this.setState({ pager: pager });
      if (serverSide) {
        this.props.onChangePage(page);
      } else {
        this.props.onChangePage([]);
      }
      return;
    }

    if (page < 1 || page > Math.ceil(totalCount / pageSize)) {
      return;
    }

    // get new pager object for specified page
    pager = this.getPager(totalCount, page, pageSize);

    // get new page of items from items array
    let pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

    // update state
    this.setState({ pager: pager });

    // call change page function in parent component
    if (serverSide) {
      this.props.onChangePage(page);
    } else {
      this.props.onChangePage(pageOfItems);
    }
  };

  getPager = (totalItems, currentPage, pageSize) => {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    let startPage, endPage;
    if (totalPages <= 5) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 4;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 3;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = [...Array(endPage + 1 - startPage).keys()].map(
      (i) => startPage + i
    );

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  };

  render() {
    let pager = this.state.pager;

    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null;
    }

    return (
      <div className="row pro-result">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 pagination-style">
          <div className="pagination">
            <ul>
              <li>
                <button
                  disabled={pager.currentPage === 1}
                  onClick={() =>
                    this.setPage(pager.currentPage - pager.currentPage)
                  }
                >
                  {"<<"}
                </button>
              </li>
              <li>
                <button
                  disabled={pager.currentPage === 1}
                  onClick={() => this.setPage(pager.currentPage - 1)}
                >
                  {"<"}
                </button>
              </li>
              {pager.pages.map((page, index) => (
                <li key={index}>
                  <button
                    className={
                      pager.currentPage === page ? "active bg-info" : ""
                    }
                    onClick={() => this.setPage(page)}
                  >
                    {page}
                  </button>
                </li>
              ))}
              <li>
                <button
                  disabled={pager.currentPage === pager.totalPages}
                  onClick={() => this.setPage(pager.currentPage + 1)}
                >
                  {">"}
                </button>
              </li>
              <li>
                <button
                  disabled={pager.currentPage === pager.totalPages}
                  onClick={() =>
                    this.setPage(pager.currentPage + pager.totalPages - 1)
                  }
                >
                  {">>"}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Pagination;
